import { useEffect, useRef } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import type { BeautyInfo } from 'shared/src/api/getMemberInfo/types';

export const useLogViewMyPersonalization = (params: {
  height: number | null;
  weight: number | null;
  topLabel: string | null;
  bottom: number | null;
  shoes: number | null;
  skinTone: BeautyInfo | null;
  skinType: BeautyInfo | null;
  skinProblems: BeautyInfo[] | null;
  from: string | undefined;
}) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const loggedRef = useRef(false);

  useEffect(() => {
    if (loggedRef.current) return;
    loggedRef.current = true;

    logAnalyticsEvent({
      name: 'VIEW_MY_PERSONALIZATION',
      channel: ['firebase', 'facebook', 'amplitude', 'ablylog'],
      analytics: {
        HEIGHT: params.height,
        WEIGHT: params.weight,
        TOP: params.topLabel,
        PANTS: params.bottom,
        SHOES: params.shoes,
        SKIN_TONE: params.skinTone?.name ?? null,
        SKIN_TYPE: params.skinType?.name ?? null,
        SKIN_PROBLEMS:
          params.skinProblems != null
            ? `[${params.skinProblems.map(p => p.name).join(', ')}]`
            : null,
        FROM: params.from ?? null,
      },
    });
  }, [params, logAnalyticsEvent]);
};
